import {createEntityAdapter, EntityAdapter, EntityState} from "@ngrx/entity";
import {PaginationModel} from "@shared/models/pagination.model";
import {ConfigService} from "@config/config.service";
import {BillingInvoiceModel} from "@services/back-office/model/billingInvoiceModel";
import {BillingInvoiceSearchModel} from "@services/back-office/model/billingInvoiceSearchModel";
import {InvoicesActions, InvoicesActionTypes} from "@billing/ngrx/actions/invoices.actions";

export const adapter: EntityAdapter<BillingInvoiceModel> = createEntityAdapter<BillingInvoiceModel>();

export interface State extends EntityState<BillingInvoiceModel> {
    loading: boolean,
    loadingItem: string
    pagination: PaginationModel,
    filter: BillingInvoiceSearchModel
}

export const initialState: State = adapter.getInitialState({
    loading: false,
    loadingItem: '',
    pagination: {
        first: true,
        last: false,
        number: 0,
        numberOfElements: 0,
        size: new ConfigService().paginationConfig.pageSize,
        totalElements: 0,
    },
    filter: {}
});

export function reducer(state = initialState, action: InvoicesActions): State {
    switch (action.type) {
        case InvoicesActionTypes.LoadInvoices:
            return {...state, loading: !action.payload?.dontShowLoading};

        case InvoicesActionTypes.LoadInvoicesSuccess:
            return adapter.setAll(action.payload.content!, {
                ...state,
                loading: false,
                pagination: {
                    size: action.payload.size,
                    last: action.payload.last,
                    totalElements: action.payload.totalElements,
                    numberOfElements: action.payload.numberOfElements,
                    first: action.payload.first,
                    number: action.payload.number,
                }
            });

        case InvoicesActionTypes.LoadInvoicesFailure:
            return {...state, loading: false};

        case InvoicesActionTypes.EditInvoice:
            return {...state, loadingItem: action.payload.id!};

        case InvoicesActionTypes.EditInvoiceSuccess:
            return adapter.updateOne({id: action.payload.id!, changes: action.payload}, {...state, loadingItem: ''});

        case InvoicesActionTypes.EditInvoiceFailure:
            return {...state, loadingItem: ''};

        case InvoicesActionTypes.DeleteInvoice:
            return {...state, loadingItem: action.payload};

        case InvoicesActionTypes.DeleteInvoiceSuccess:
            return adapter.removeOne(action.payload, {...state, loadingItem: ''});

        case InvoicesActionTypes.DeleteInvoiceFailure:
            return {...state, loadingItem: ''};

        case InvoicesActionTypes.ChangePage:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    number: action.payload.number,
                    size: action.payload.size
                }
            };

        case InvoicesActionTypes.SetInitialPagination:
            return {...state, pagination: initialState.pagination};

        case InvoicesActionTypes.SetFilter:
            return {...state, filter: action.payload};

        case InvoicesActionTypes.ClearFilter:
            return {...initialState};

        default:
            return state;
    }
}

export const {
    selectIds: selectInvoicesIds,
    selectAll: selectAllInvoices
} = adapter.getSelectors();
